"use strict";

exports.__esModule = true;
exports.getResultsById = getResultsById;

function getResultsById(results = [], resultsById = {}) {
  results.forEach(item => {
    const uniqueId = item.uniqueId;
    console.log('item', item);

    if (item.uniqueId) {
      resultsById[item.uniqueId] = item;
    }
  });
  return resultsById;
}